import { useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import type { IInitMapResult } from 'components/map/map-container/hooks/types.ts';

const loader = new Loader({
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['marker', 'geometry'],
});

loader
  .importLibrary('maps')
  .then(() => {})
  .catch((e) => {
    console.error('google map init error');
    console.error(e);
  });

const DEFAULT_ZOOM = 6;
const DEFAULT_CENTER = { lat: 52, lng: 18.7 };

const mapOptions: google.maps.MapOptions = {
  zoom: DEFAULT_ZOOM,
  center: DEFAULT_CENTER,
  mapId: import.meta.env.VITE_GOOGLE_MAP_ID,
};

export const useInitMap = (): IInitMapResult => {
  const mapBoxRef = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map | null>(null);

  useEffect(() => {
    if (!map) {
      if (mapBoxRef.current) {
        const newMap = new (window.google?.maps?.Map ?? google.maps.Map)(mapBoxRef.current, mapOptions);
        setMap(newMap);
      } else {
        console.error('mapBoxRef.current is undefined');
      }
    }
  }, []);

  return { mapBoxRef, map };
};
